export default "__VITE_ASSET__0cd4f908__"